// @flow

import "./add-to-cart";

import initImages from "./image-fetch";
import initJSFromRelab from "./raw-from-relab";
import initSideBarRedirect from "./sidebar-redirect";
import initPrices from "./product-pricing";
import {initPostcodeUpdater} from "./postcode-updator";
import initDropdowns from "./dropdown-default-selection";
import initSortSelections from "./sort-order-selection";
import initLearning from "./learning";
import {initQuantityValidation} from "./quantity";
import initViewPreference from "./preference/view";
import initClearance from "./clearance";
import initBadge from "./badge";
import {initStockAvailabilityPill} from "./stock-availability-pill"
import {initBranchSelector} from "./branch-selector/branchSelector";
import {initAlertDialog} from "./alert-dialog/alertDialog";
import {initStickyHeader} from "./sticky-header/stickyHeader";
import {fetchUserDetails} from "./user-details/fetchUserDetails";
import {initSearchAnalytics} from "./search-analytics/searchAnalytics";
import {initProductTile} from "./product-tile/productTile";


function reportError(e) {
  try {
    console.error(e);
    window.Raven && window.Raven.captureException(e);
  } catch(e2) {
    console.error(e2);
  }
}
const getUserType = (win) => {
  const wrapper = win.document.querySelector(`.product-search-page-body-wrapper`);
  return wrapper ? wrapper.getAttribute('data-user-type') : null;
}

export async function initSearchPage(win: WindowProxy) {
  const userDetails = getUserType(win) === 'MAX_USER' ? await fetchUserDetails() : null

  try { initSearchAnalytics(win);     } catch(e) { reportError(e); }
  try { initImages(win);              } catch(e) { reportError(e); }
  try { initJSFromRelab();            } catch(e) { reportError(e); }
  try { initSideBarRedirect(win);     } catch(e) { reportError(e); }
  try { initPrices(win); } catch(e) { reportError(e); }
  try { initPostcodeUpdater(win);     } catch(e) { reportError(e); }
  try { initDropdowns(win);           } catch(e) { reportError(e); }
  try { initSortSelections(win);      } catch(e) { reportError(e); }
  try { initLearning(win);            } catch(e) { reportError(e); }
  try { initQuantityValidation(win); } catch(e) { reportError(e); }
  try { initViewPreference(win);      } catch(e) { reportError(e); }
  try { initViewPreference(win);      } catch(e) { reportError(e); }
  try { initClearance(win);           } catch(e) { reportError(e); }
  try { initBadge(win);               } catch(e) { reportError(e); }
  try { await initStockAvailabilityPill(win, userDetails); } catch(e) { reportError(e); }
  try { await initBranchSelector(win, userDetails); } catch(e) { reportError(e); }
  try { initStickyHeader(win) } catch(e) { reportError(e); }
  try { initAlertDialog(win); } catch(e) { reportError(e); }
  try { initProductTile(win); } catch(e) { reportError(e); }
}

document.addEventListener("DOMContentLoaded", function() {
  initSearchPage(window);
});



// WEBPACK FOOTER //
// ./javascript/product-search-page/index.js